module.exports = __webpack_public_path__ + "img/clients.5018dda1.svg";